import React from 'react'

export default function RejectedVideoIcon({color}) {
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <g clipPath="url(#clip0_2_1140)">
            <path d="M11 22C4.93452 22 0 17.0655 0 11C0 4.93452 4.93452 0 11 0C17.0655 0 22 4.93452 22 11C22 17.0655 17.0655 22 11 22ZM11 1.57138C5.80112 1.57138 1.57138 5.80112 1.57138 11C1.57138 16.1989 5.80112 20.4286 11 20.4286C16.1989 20.4286 20.4286 16.1989 20.4286 11C20.4286 5.80112 16.1989 1.57138 11 1.57138Z" fill={ color? color : `#8B0000`}/>
            <path d="M14.9286 15.7143C14.7275 15.7143 14.5265 15.6376 14.3731 15.484L6.51598 7.62696C6.20899 7.31996 6.20899 6.8228 6.51598 6.51598C6.8228 6.20915 7.32013 6.20899 7.62696 6.51598L15.484 14.373C15.791 14.68 15.791 15.1772 15.484 15.484C15.3306 15.6376 15.1297 15.7143 14.9286 15.7143Z" fill={ color? color : `#8B0000`}/>
            <path d="M7.07138 15.7143C6.8703 15.7143 6.66939 15.6376 6.51598 15.484C6.20899 15.1772 6.20899 14.6799 6.51598 14.3731L14.3731 6.51598C14.68 6.20899 15.1772 6.20899 15.484 6.51598C15.7909 6.8228 15.791 7.32013 15.484 7.62696L7.62696 15.484C7.47355 15.6376 7.27246 15.7143 7.07138 15.7143Z" fill={ color? color : `#8B0000`}/>
        </g>
        <defs>
            <clipPath id="clip0_2_1140">
            <rect width="22" height="22" fill="white"/>
            </clipPath>
        </defs>
        </svg>
  )
}
